import { render, staticRenderFns } from "./ProductModelDelivered.vue?vue&type=template&id=05231828&"
import script from "./ProductModelDelivered.vue?vue&type=script&lang=js&"
export * from "./ProductModelDelivered.vue?vue&type=script&lang=js&"
import style0 from "./ProductModelDelivered.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports